import React from 'react'
import TuneOutlinedIcon from "@material-ui/icons/Tune";
import "./SearchPage.css";
import ChannelRow from './ChannelRow';
import VideoRow from './VideoRow';

function SearchPage() {
    return (
        <div className="searchPage">
            <div className="searchPage__filter">
                <TuneOutlinedIcon />
                <h2>Filter</h2>
            </div>
            <hr />
            <ChannelRow 
            image="https://www.thenerdmag.com/wp-content/uploads/2019/11/COD-Mobile-1.jpg"
            Channel="COD Mobile"
            verified
            subs="22M"
            noofVideos={598}
            description="Experience the thrill of Call of Duty on the go. Play as iconic characters in battle royale and multiplayer in our best fps free mobile game. Download free now."
            />
<hr />

<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>
<VideoRow 
views="1.4M"
subs="348k"
description="Experience the thrill of Call of Duty on the go."
timestamp="1 minute ago"
channel="COD Mafia"
title="Experience the thrill of Call of Duty on the go Download free now."
image="https://wallpapertag.com/wallpaper/middle/2/8/2/150320-cod-wallpaper-1920x1080-htc.jpg"
/>


        </div>
    )
}

export default SearchPage
